import { Component, OnInit, OnDestroy } from '@angular/core';
import { RouterOutlet } from '@angular/router';
import { CommonModule } from '@angular/common';
import { HeaderComponent } from './shared/components/header/header';
import { SidebarComponent } from './shared/components/sidebar/sidebar';
import { NetworkStatusBannerComponent } from './shared/components/network-status-banner/network-status-banner.component';
import { FloatingCalendarButtonComponent } from './shared/components/floating-calendar-button/floating-calendar-button.component';
import { AuthService } from './services/auth.service';
import { SystemSettingsService } from './services/system-settings.service';
import { AutoLogoutService } from './services/auto-logout.service';
import { NetworkStatusService } from './services/network-status.service';
import { Subscription } from 'rxjs';

@Component({
  selector: 'app-root',
  imports: [RouterOutlet, HeaderComponent, SidebarComponent, NetworkStatusBannerComponent, FloatingCalendarButtonComponent, CommonModule],
  templateUrl: './app.html',
  styleUrl: './app.scss'
})
export class App implements OnInit, OnDestroy {
  protected title = 'CRM System';
  public isLoggedIn$;
  private loginSubscription?: Subscription;

  constructor(
    private authService: AuthService,
    private systemSettingsService: SystemSettingsService,
    private autoLogoutService: AutoLogoutService,
    private networkStatusService: NetworkStatusService
  ) {
    this.isLoggedIn$ = this.authService.isLoggedIn$;
  }

  ngOnInit(): void {
    // Automatikus kijelentkezés inicializálása ha be van jelentkezve a felhasználó
    this.loginSubscription = this.authService.isLoggedIn$.subscribe(isLoggedIn => {
      if (isLoggedIn && this.authService.isAuthenticated()) {
        // Beállítás betöltése és auto-logout indítása (csak érvényes token esetén)
        this.systemSettingsService.getAutoLogoutSetting().subscribe({
          next: (response) => {
            this.autoLogoutService.startMonitoring(response.enabled);
          },
          error: (error) => {
            console.error('Hiba a beállítás betöltésekor:', error);
            // Alapértelmezetten bekapcsolva
            this.autoLogoutService.startMonitoring(true);
          }
        });
      } else {
        // Ha nincs bejelentkezve, leállítjuk a figyelést
        this.autoLogoutService.stopMonitoring();
      }
    });
  }

  ngOnDestroy(): void {
    this.loginSubscription?.unsubscribe();
  }
}
